module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAFVBMVEUgRoy3PEghRouottKuHCjgp6z////2S0q7AAAAAnRSTlPU/snCEjgAAAA3SURBVEjH7csxAQAgEMSws4AFLGABC1jAv4TX0PmaPVlYLmaxWErLw/Ixi8VSWg6WjVksltLCDabgYsiD0xdmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/nl.png
// module id = qtnE
// module chunks = 0